module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading\n"
    }],
    staticClass: "coupon-tips sl-coupon"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponsTips.title')))]), _vm._v(" "), _c('img', {
    staticClass: "coupon-tips-center",
    attrs: {
      "src": require("../../assets/imgs/center.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "coupon-tips-1"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponsTips.tip1')))]), _vm._v(" "), _c('p', {
    staticClass: "coupon-tips-2"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponsTips.tip2')))]), _vm._v(" "), _c('img', {
    staticClass: "coupon-tips-down",
    attrs: {
      "src": require("../../assets/imgs/down.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-tips-btm"
  }, [_c('div', {
    staticClass: "coupon-tips-btm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/letter.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-tips-btm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.number))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37cfce8d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coupons/coupon-tips.vue
// module id = 1099
// module chunks = 1